
export const autoActionConstants = {
    GET_AUTO_ACTION_REQUEST: 'GET_AUTO_ACTION_REQUEST',
    GET_AUTO_ACTION_SUCCESS: 'GET_AUTO_ACTION_SUCCESS',
    GET_AUTO_ACTION_FAILURE: 'GET_AUTO_ACTION_FAILURE',

    CREATE_OR_UPDATE_AUTO_ACTION_REQUEST: 'CREATE_OR_UPDATE_AUTO_ACTION_REQUEST',
    CREATE_OR_UPDATE_AUTO_ACTION_SUCCESS: 'CREATE_OR_UPDATE_AUTO_ACTION_SUCCESS',
    CREATE_OR_UPDATE_AUTO_ACTION_FAILURE: 'CREATE_OR_UPDATE_AUTO_ACTION_FAILURE',
}